import { 
  HANDLE_NOTIFICATION,
  SHOW_GLOBAL_DIALOG, 
  HIDE_GLOBAL_DIALOG,
  SHOW_GLOBAL_POPUP,
  HIDE_GLOBAL_POPUP
} from "@/actions/actionType";

const notificationReducer = (state = {},  action) => {
  console.log('notificationReducer', action);
  switch (action.type) {
    case HANDLE_NOTIFICATION:
      return {...state, message: action.content};
    case SHOW_GLOBAL_DIALOG:
      return {...state, globalDialogState: true };
    case SHOW_GLOBAL_POPUP:
      return {...state, globalPOPUPState: true};
    case HIDE_GLOBAL_DIALOG:
      return {...state, globalDialogState: false, message: null};
    case HIDE_GLOBAL_POPUP:
      return {...state, globalPOPUPState: false, message: null};
    default:
      return state;
  }
}

export default notificationReducer